<template>
    <div class="panel-case">
        <div class="index-container">
            <div class="index-title-group">
                <div class="index-title"><div>行业案例</div></div>
                <div class="index-title-sub">创新的数字工厂平台，颠覆传统工业领域</div>
            </div>
            <div class="case-body">
                <div class="case-menu">
                    <div class="case-menu-item main">行业案例</div>
                    <div class="case-menu-item">
                        <div class="case-title">机械加工行业</div>
                        <div class="case-icon"><i class="fa fa-angle-right"></i></div>
                    </div>
                    <div class="case-menu-item">
                        <div class="case-title">装备制造行业</div>
                        <div class="case-icon"><i class="fa fa-angle-right"></i></div>
                    </div>
                    <div class="case-menu-item">
                        <div class="case-title">橡胶及塑料行业</div>
                        <div class="case-icon"><i class="fa fa-angle-right"></i></div>
                    </div>
                    <div class="case-menu-item">
                        <div class="case-title">纺织服装行业</div>
                        <div class="case-icon"><i class="fa fa-angle-right"></i></div>
                    </div>
                    <div class="case-menu-item">
                        <div class="case-title">再生资源行业</div>
                        <div class="case-icon"><i class="fa fa-angle-right"></i></div>
                    </div>
                </div>
                <div class="case-container">
                    <div class="case-card-box">
                        <div class="case-card card-1">
                            <div class="case-card-footer">再生塑料加工-MES系统</div>
                        </div>
                    </div>
                    <div class="case-card-box">
                        <div class="case-card card-2">
                            <div class="case-card-footer">轴承加工-MES系统</div>
                        </div>
                    </div>
                    <div class="case-card-box">
                        <div class="case-card card-3">
                            <div class="case-card-footer">注塑加工-MES系统</div>
                        </div>
                    </div>
                    <div class="case-card-box">
                        <div class="case-card card-4">
                            <div class="case-card-footer">轧辊加工-MES系统</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "case"
    }
</script>

<style scoped>
    .panel-case {
        padding: 65px 0 45px;
        background-color: #FFFFFF;
    }

    .case-body {
        padding-top: 25px;
        display: flex;
    }

    .case-menu-item {
        display: flex;
        align-items: center;
        font-size: 22px;
        line-height: 22px;
        font-weight: bolder;
        background-color: #0171cb;
        color: #FFFFFF;
        width: 270px;
        height: 120px;
        padding: 20px 40px;
    }

    .case-menu-item.main {
        background-color: #ebf2f8;
        color: #0171cb;
    }

    .case-menu-item .case-title {
        flex: 1;
    }

    .case-menu-item .case-icon {
        margin-left: 15px;
        font-size: 30px;
        line-height: 30px;
    }

    .case-container {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        margin: -2px 0;
    }

    .case-card-box {
        width: 50%;
        padding: 2px;
    }

    .case-card {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .card-1 {
        background-image: url("../../resource/img/index/case/1.png");
        background-size: 100% 100%;
    }
    .card-2 {
        background-image: url("../../resource/img/index/case/2.jpg");
        background-size: 100% 100%;
    }
    .card-3 {
        background-image: url("../../resource/img/index/case/3.png");
        background-size: 100% 100%;
    }
    .card-4 {
        background-image: url("../../resource/img/index/case/4.png");
        background-size: 100% 100%;
    }

    .case-card-footer {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .6);
        color: #fff;
        font-size: 18px;
        padding: 15px 0;
        text-align: center;
    }
</style>
